import type {
  ModuleEntity,
  ModuleResult,
} from '@/domains/careerLayer/careerLayer.entity';

/**
 * UseCase para transformar módulos de dominio a formato UI con porcentaje calculado
 *
 * Responsabilidades:
 * - Recibir módulos con cantidad de estudiantes y estudiantes en riesgo
 * - Calcular porcentaje de riesgo para cada módulo
 * - Retornar módulos enriquecidos con el campo porcentaje_riesgo
 */
export class TransformCareerLayerModulesToUIUseCase {
  /**
   * Ejecuta la transformación agregando porcentaje de riesgo a cada módulo
   * @param modules - Array de módulos de dominio
   */
  execute(modules: ModuleEntity[]): ModuleResult[] {
    return modules.map((module) => ({
      ...module,
      porcentaje_riesgo:
        module.cantidad_estudiantes > 0
          ? Math.round(
              (module.estudiantes_con_riesgo / module.cantidad_estudiantes) *
                100,
            )
          : 0,
    }));
  }
}
